"use client";

import React from "react";
import { Leaf, FlaskConical, Users, ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const valuesData = [{
  title: "Holistic Wellness",
  description: "We believe in nurturing the mind, body, and spirit as an interconnected system, honoring our founder's vision of comprehensive health.",
  icon: Leaf
}, {
  title: "Scientific Rigor",
  description: "Every protocol is grounded in evidence-based research, ensuring that our methods are both safe and highly effective.",
  icon: FlaskConical
}, {
  title: "Empowering Community",
  description: "We foster a compassionate, supportive environment where every member is empowered to take control of their wellness journey.",
  icon: Users
}, {
  title: "Unwavering Integrity",
  description: "Transparency and trust are the cornerstones of our practice, guiding every interaction and recommendation we make.",
  icon: ShieldCheck
}];
export default function OurMissionValues() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-mission-values" className="py-20 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        {}
        <div ref={headerRef} className={cn("max-w-3xl mx-auto text-center mb-16 md:mb-24 transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-4xl md:text-6xl font-bold font-default mb-6 tracking-tight">
            The Mission Today
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
            To provide intentional, personalized wellness protocols that help people truly measure, optimize, perform, and maintain their health. Everything we do is rooted in that purpose. And everything we build moving forward is in honor of her.
          </p>
        </div>

        {}
        <div ref={cardsRef} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-16 md:mb-24 transition-all duration-1000 ease-out delay-200", areCardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {valuesData.map((item, i) => <Card key={i} data-index={i} className="border-border/50 bg-[var(--color-green-accent)]/5 rounded-lg backdrop-blur-sm hover:shadow-md hover:border-[var(--color-green-accent)]/30 transition-all duration-300 group">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-xl bg-[var(--color-green-accent)]/10 flex items-center justify-center mb-4 group-hover:bg-[var(--color-green-accent)]/20 transition-colors duration-300">
                  <item.icon className="size-6 text-[var(--color-green-accent)]" />
                </div>
                <CardTitle className="font-default font-bold text-lg uppercase tracking-wider">{item.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground leading-relaxed font-default">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div ref={ctaRef} className={cn("flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 transition-all duration-700 ease-out delay-400", isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <Link to="/ProtocolsPage" className="w-full sm:w-auto">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-medium bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 transition-all shadow-lg shadow-[var(--color-green-accent)]/10">
              Explore Our Protocols
            </Button>
          </Link>
          <Link to="/MembershipsPage" className="w-full sm:w-auto">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-medium bg-[var(--color-green-accent)] hover:bg-[var(--color-green-accent)]/90 text-white shadow-lg shadow-[var(--color-green-accent)]/20 transition-all">
              Join Our Membership
              <ArrowRight className="ml-2 size-5" />
            </Button>
          </Link>
        </div>

      </div>
    </section>;
}